import { ResponsiveDialog } from 'common-frontend'
import { Button, HelpEmail } from 'components'
import { AnalyticsUtils } from 'utils'

export default class InstalledDialog extends React.Component {
  static contextTypes = {
    currentUser: React.PropTypes.object,
  }

  static propTypes = {
    installed: React.PropTypes.bool.isRequired,
    upgrade: React.PropTypes.bool.isRequired,
    handleRequestInstall: React.PropTypes.func.isRequired,
    handleSelfInstall: React.PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props)

    this.state = { show: true, showInstructions: false, installMethod: null }
  }

  requestInstall() {
    this.setState({ installMethod: 'requested' })

    this.props.handleRequestInstall()
  }

  selfInstall() {
    this.setState({ installMethod: 'self' })

    this.props.handleSelfInstall()
  }

  buttons() {
    if (this.state.installMethod) {
      return <Button
        label="Close"
        buttonType="secondary"
        onTouchTap={ () => this.setState({show: false}) }
      />
    }

    return (
      <div>
        <Button
          label="Yes, install the code for me"
          buttonType="primary"
          onTouchTap={::this.requestInstall}
        />
        <Button
          label="No, I can install it myself"
          buttonType="secondary"
          className="secondary-btn"
          onTouchTap={::this.selfInstall}
        />
      </div>
    )
  }

  instructions() {
    return (
      <div>
        { this.state.installMethod != 'self' && <h4 className="large-spacing2--top">How to install Plug in SEO code:</h4> }
        <ol className="list medium-spacing--bottom">
          { this.props.hasInclude !== true && (
            <div>
              <li className="list__item">In your theme editor open up Layout &gt; theme.liquid</li>
              <li className="list__item">After the &lt;head&gt; include the snippet by pasting in this code: &#123;% include 'pluginseo' %&#125;</li>
            </div>
          ) }
          <li className="list__item">You should comment out the code that currently generates your page titles and meta descriptions to avoid duplicates. It goes something like...</li>
          <li className="list__item">Find the code in theme.liquid or a snippet it uses to generate the &lt;title&gt;</li>
          <li className="list__item">Comment it out by surrounding it with &#123;% comment %&#125; and &#123;% endcomment %&#125;</li>
          <li className="list__item">Do the same for &lt;meta name="description"</li>
        </ol>
      </div>
    )
  }

  handleToggleInstructions() {
    const newState = !this.state.showInstructions
    this.setState({ showInstructions: newState })

    newState && AnalyticsUtils.installInstructionsViewed("InstalledDialog")
  }

  instructionsToggler() {
    return (
      <p className="small-spacing--top body2">
        <a onTouchTap={::this.handleToggleInstructions}>
          { this.state.showInstructions ? "Hide" : "View" } Instructions
        </a>
      </p>
    )
  }

  handleClickAddAccountUrl() {
    AnalyticsUtils.clickedAddStaffAccountLink()
  }

  body() {
    if (this.props.upgrade) {
      return <p>Any questions? Just email <HelpEmail /></p>
    }

    if (this.state.installMethod === "requested") {
      const add_account_url = `https://${this.context.currentUser.shop}/admin/settings/account/new`

      return (
        <div>
          <p>To install Plug in SEO we need access to your theme.</p>
          <p className="medium-spacing--top">Please <a onTouchTap={::this.handleClickAddAccountUrl} href={add_account_url} target="_blank">add help@pluginseo.com</a> as a staff member in your Shopify admin.</p>
          <p className="medium-spacing--top">One of our team members will add this last piece of code to your theme and email you.</p>
          <p className="medium-spacing--top">Need any more help? Email us at <HelpEmail/></p>
        </div>
      )
    }

    if (this.state.installMethod === "self") {
      return (
        <div>
          { this.instructions()  }
          <p className="medium-spacing--top">Need help? Email us at <HelpEmail/></p>
        </div>
      )
    }

    return (
      <div>
        <p>One last piece of code needs to be added manually.</p>

        { this.state.showInstructions && this.instructions() }
        { this.instructionsToggler() }
        <p className="large-spacing--top">Would you like us to do that for you free of charge?</p>
      </div>
    )
  }

  title() {
    if (this.state.installMethod === 'self') return "Installing Plug in SEO Code"
    if (this.state.installMethod === 'requested') return "Can you give us access to your shop?"

    return "Success! Plug in SEO Plus is now installed in your shop"
  }

  render() {
    return (
      <ResponsiveDialog
        title={this.title()}
        maxWidth="600px"
        modal={true}
        open={this.state.show}
        onRequestClose={() => this.setState({ show: false }) }
      >
        <div>
          <div style={{ whiteSpace: 'pre-line' }} className="large-spacing2">
            { this.body() }
          </div>
          { this.buttons() }
        </div>
      </ResponsiveDialog>
    )
  }
}



// WEBPACK FOOTER //
// ./app/components/plus/InstalledDialog.js